import {ComparisonTableResponseType, Nullable} from "../../definitions/types";
import {ComparisonTableModel} from "../domain/comparisonTableModel";

export class ComparisonTableResponseModel {
    private readonly _id?: number;
    private readonly _comparisonTable: ComparisonTableModel;

    constructor(comparisonTableResponseType: Nullable<ComparisonTableResponseType>) {
        this._id = comparisonTableResponseType?.id;
        this._comparisonTable = new ComparisonTableModel(comparisonTableResponseType?.comparisonTable);
    }

    /**
     * @property breakOutEarly
     * @description Whether to break out early (render nothing)
     * @return {boolean}
     */
    public get breakOutEarly(): boolean {
        if (!this._id) return true;
        if (!this._comparisonTable) return true;
        return !this._comparisonTable.hasItems;
    }

    /**
     * @property id
     * @description The id of the comparison table
     * @return {number | undefined}
     */
    public get id(): number | undefined {
        return this._id;
    }

    /**
     * @property comparisonTable
     * @description The comparison table
     * @return {ComparisonTableModel}
     */
    public get comparisonTable(): ComparisonTableModel {
        return this._comparisonTable;
    }
}